import panelTrendsUi from './panel-trends-ui'

export default {
    panelTrendsUi
}
